import React, { Fragment } from "react";
import DocumentModal from "./components/DocumentModal";
import DocumentManagerModalProvider from "./components/DocumentManagerModalProvider";
import { useDocuments } from "./hooks/useDocuments";
import { useDocumentModal } from "./hooks/useDocumentModal";
import { useDocumentLinkContext } from "./providers/DocumentLinkContext";
import { AddDocumentRequest, EditDocumentRequest } from "./types";
import { DocumentsTable } from "./components/DocumentsTable";

const DocumentManagerApp: React.FC = () => {
  const { linkTargetId } = useDocumentLinkContext();

  const documents = useDocuments({
    initialFilters: {
      pageSize: 5
    }
  });

  const {
    isOpen,
    mode,
    selectedDocument,
    openAddModal,
    openEditModal,
    closeModal
  } = useDocumentModal();

  const [saveError, setSaveError] = React.useState<string | null>(null);

  const handleSaveDocument = async (
    data: AddDocumentRequest | EditDocumentRequest
  ) => {
    setSaveError(null);

    let result;
    if (mode === "create") {
      result = await documents.addDocument(data as AddDocumentRequest);
    } else {
      result = await documents.editDocument(data as EditDocumentRequest);
    }

    if (result.success) {
      closeModal();
      setSaveError(null);
    } else {
      setSaveError(
        result.message || "An error occurred while saving the document"
      );
    }
  };

  const handleCloseModal = () => {
    setSaveError(null);
    closeModal();
  };

  return (
    <DocumentManagerModalProvider>
      <Fragment>
        <div className="w-full">
          <DocumentsTable
            documents={documents}
            onDocumentClick={openEditModal}
            onAddDocument={openAddModal}
          />
        </div>

        <DocumentModal
          isOpen={isOpen}
          onClose={handleCloseModal}
          document={selectedDocument}
          projectId={linkTargetId}
          onSave={handleSaveDocument}
          mode={mode}
          saveError={saveError}
        />
      </Fragment>
    </DocumentManagerModalProvider>
  );
};

export default DocumentManagerApp;
